<template>
    <DesignAddMediaPhoto  @completed="emits('next')"></DesignAddMediaPhoto>

</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { usePreviewStore } from '../../stores';
import DesignAddMediaPhoto from './design-add-media-photo.vue';
import DesignAddMediaVideo from './design-add-media-video.vue';

const emits = defineEmits(['next']);

const previewStore = usePreviewStore();
const { selectedMediaType } = storeToRefs(previewStore);

selectedMediaType.value = 'picture';


</script>

<style lang="scss">
.btn.btn-radio-select-media {
    border-color: $white;
    transition: border-color 0.2s ease-in-out 0s;

    &.active {
        border-color: $primary;
        color: $primary;
    }
}
</style>